import React, { useState } from 'react';
import { Modal, Row, Col, Button, Card, Form } from 'react-bootstrap';
import axios from 'axios';
import { InputGroup, InputGroupText, FormControl, FormCheck } from 'react-bootstrap';
import InputMask from 'react-input-mask';
import { useRef } from 'react';
const Balance = ({ show, onHide, profile }) => {

  const [selectedAmount, setSelectedAmount] = useState(null);
  const [selectedCard, setSelectedCard] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const cardRef = useRef(null);
  const expRef = useRef(null);
  const cvvRef = useRef(null);
  const [customAmount, setCustomAmount] = useState('');

  const balancePackages = [20, 50, 100, 200, 500];

  const handlePurchase = async (e) => {
	e.preventDefault();
    const amount = selectedAmount === 'custom' ? parseInt(customAmount) : selectedAmount;
    
    if (!amount || !selectedCard) {
      console.error('Purchase validation failed:', {
        amount: amount || 'missing',
        selectedCard: selectedCard || 'missing'
      });
      alert('Please select both an amount and a payment method');
      return;
    }

    setLoading(true);
    try {
      let data = {};
      if (selectedCard === 'addCard') {
        // Validate card details before submitting
        const cardNumber = cardRef.current.value.replace(/\s/g, '');
        const expDate = expRef.current.value;
        const cvv = cvvRef.current.value;

        if (!cardNumber || !expDate || !cvv) {
          throw new Error('Please fill in all card details');
        }

        data = {
          amount: amount,
          card: cardNumber,
          exp: expDate,
          cvv: cvv
        };
      } else {
        data = {
          amount: amount,
          cardid: selectedCard
        };
      }
	  	axios.post("https://api.viralgpt.com/pixel", {
		email: profile.email,
		event: "InitiateCheckout",
		price: amount
	}, {
		withCredentials: true
	  })

      const response = await axios.post('https://api.viralgpt.com/purchase/balance', data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`
        }
      });

      if (response.data.success) {
		axios.post("https://api.viralgpt.com/pixel", {
			email: profile.email,
			event: "Purchase",
			price: amount
		}, {
			withCredentials: true
		})
        onHide();
        window.location.reload();
      } else {
        throw new Error(response.data.message || 'Payment failed');
      }
    } catch (err) {
      alert(err.response.data.error || 'Payment failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title className="text-instagram font-bold text-2xl">Add Balance</Modal.Title>
      </Modal.Header>
      <Modal.Body>
       

		

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-4">
          {balancePackages.map((amount) => (
            <div 	
              key={amount}
              className={`cursor-pointer transition-all ${selectedAmount === amount ? 'border-instagram' : 'border border-2'} rounded-lg p-4 text-center hover:border-instagram`}
              onClick={() => setSelectedAmount(amount)}
            >
              <div>
                <span className="text-2xl font-bold text-instagram">${amount}</span>
              </div>
            </div>
          ))}
          <div
            className={`cursor-pointer transition-all ${selectedAmount === 'custom' ? 'border-instagram' : 'border border-2'} rounded-lg p-4 text-center hover:border-instagram`}
            onClick={() => setSelectedAmount('custom')}
          >
            <div>
              <span className="text-2xl font-bold text-instagram">Custom</span>
            </div>
          </div>
        </div>
        {selectedAmount === 'custom' && (
          <div className="mb-4">
            <InputGroup>
              <InputGroup.Text>
                <i className="fa-solid fa-dollar-sign text-instagram" />
              </InputGroup.Text>
              <Form.Control
                type="number"
                min="1"
                max="1000"
                placeholder="Enter amount"
                value={customAmount}
                onChange={(e) => setCustomAmount(e.target.value)}
              />
            </InputGroup>
          </div>
        )}

		<div className="text-center mb-4">
			<p className="text-gray-600 text-sm">
				Your balance can be used to purchase any of our boost services.
			</p>
		</div>
        <Card className="shadow-sm mb-4">
          <Card.Body>
            <div className="flex flex-col gap-2">
              <div className="flex justify-between items-center">
                <span className="text-gray-600">Selected Amount</span>
                <span className="font-bold text-lg">
                  ${selectedAmount === 'custom' ? customAmount || 0 : selectedAmount || 0}
                </span>
              </div>

              {(selectedAmount || customAmount) && (
                <>
                 

                  <div className="border-t pt-2 mt-2">
                    <div className="flex justify-between items-center">
                      <span className="font-bold">Total</span>
                      <span className="font-bold text-xl text-instagram">
                        ${profile?.socials?.[profile?.selectedProfile]?.planName === "pro" 
                          ? ((selectedAmount === 'custom' ? parseFloat(customAmount) : selectedAmount) * 0.8).toFixed(2)
                          : (selectedAmount === 'custom' ? customAmount : selectedAmount)}
                      </span>
                    </div>
                  </div>

                 
                </>
              )}
            </div>
          </Card.Body>
        </Card>



        <Card className="shadow-sm">
          <Card.Body>
            <Form onSubmit={handlePurchase}>
              {/* Card Selection */}
              <Form.Group className="mb-3">
                <Form.Label>Payment Method</Form.Label>

                {/* Existing Cards Dropdown */}
                <div className="mb-3" style={{ maxHeight: "360px", overflowY: "auto" }}>
                  

              
                {Object.entries(profile.cards).map(([id, card]) => (
                  <div 
                    key={id} 
                    className={`saved-card-option p-3 rounded-lg mb-2 hover:border-instagram cursor-pointer transition-all ${selectedCard === id ? 'border-instagram' : ''}`}
                    onClick={() => setSelectedCard(id)}
                  >
                    <Form.Check
                      type="radio" 
                      name="savedCard"
                      id={`card-${id}`}
                      className="d-none"
                      onChange={() => setSelectedCard(id)}
                      checked={selectedCard === id}
                    />
                    <div className="d-flex align-items-center gap-2">
                      <div className="rounded-full bg-instagram/10 p-2">
                        {card.cardnumber.startsWith('4') && <i className="fa-brands fa-cc-visa text-instagram"></i>}
                        {card.cardnumber.startsWith('5') && <i className="fa-brands fa-cc-mastercard text-instagram"></i>}
                        {card.cardnumber.startsWith('3') && <i className="fa-brands fa-cc-amex text-instagram"></i>}
                        {!card.cardnumber.startsWith('3') && !card.cardnumber.startsWith('4') && !card.cardnumber.startsWith('5') && <i className="fa-solid fa-credit-card text-instagram"></i>}
                      </div>
                      <span className="font-medium">
                        •••• {card.cardnumber.slice(-4)} ({card.exp})
                      </span>
                    </div>
                  </div>
                ))}

                <div 
                  className={`saved-card-option p-3 rounded-lg mb-2 hover:border-instagram cursor-pointer transition-all ${selectedCard === 'addCard' ? 'border-instagram' : ''}`}
                  onClick={() => setSelectedCard('addCard')}
                >
                  <Form.Check
                    type="radio"
                    name="savedCard" 
                    id="card-new"
                    className="d-none"
                    onChange={() => setSelectedCard('addCard')}
                    checked={selectedCard === 'addCard'}
                  />
                  <div className="d-flex align-items-center gap-2">
                    <div className="rounded-full bg-instagram/10 p-2">
                      <i className="fa-solid fa-plus text-instagram"></i>
                    </div>
                    <span className="font-medium">
                      Add New Card
                    </span>
                  </div>
                </div>
				

                </div>
              </Form.Group>

              {/* New Card Form */}
			  {(profile.cards.length == 0 || selectedCard == 'addCard') && (
              <div className="new-card-form">
                <InputGroup className="mb-3">
                  <InputGroup.Text>
                    <i className="fa-solid fa-credit-card text-instagram" />
                  </InputGroup.Text>
                  <Form.Control
                    as={InputMask}
                    type="text"
                    ref={cardRef}
                    placeholder="Card Number"
                    mask="9999 9999 9999 9999"
                    maskChar=""
                    required
                  />
                </InputGroup>

                <div className="d-flex gap-3 mb-3">
                  <InputGroup>
                    <InputGroup.Text>
                      <i className="fa-solid fa-calendar text-instagram" />
                    </InputGroup.Text>
                    <Form.Control
                      as={InputMask}
                      maskChar=""
                      type="text"
                      ref={expRef}
                      placeholder="MM/YY"
                      mask="99/99"
                      required
                    />
                  </InputGroup>

                  <InputGroup>
                    <InputGroup.Text>
                      <i className="fa-solid fa-lock text-instagram" />
                    </InputGroup.Text>
                    <Form.Control
                      as={InputMask}
                      maskChar=""
                      type="text"
                      ref={cvvRef}
                      placeholder="CVV"
                      mask="9999"
                      required
                    />
                  </InputGroup>
                </div>
              </div>
			  )}

              <Button
                type="submit"
                variant="primary"
                className="w-100 bg-instagram border-0 hover:bg-instagram/90"
                disabled={loading}
              >
                {loading ? 'Processing...' : `Pay $${selectedAmount === 'custom' ? customAmount || 0 : selectedAmount || 0}`}
              </Button>
            </Form>
          </Card.Body>
        </Card>
      </Modal.Body>
    </Modal>
  );
};

export default Balance;
